import { render } from "./AdminProfile.vue?vue&type=template&id=dc168014&scoped=true"
import script from "./AdminProfile.vue?vue&type=script&lang=js"
export * from "./AdminProfile.vue?vue&type=script&lang=js"

import "./AdminProfile.vue?vue&type=style&index=0&id=dc168014&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc168014"]])

export default __exports__